import React from "react";

function ViewAmenities({ data }) {

  return (
    <div className="custom-modal-body text-center">

      {/* IMAGE */}
      <div className="mb-3">
        <img
          src={`http://localhost:5000/uploads/amenities/${data?.image}`}
          alt={data?.name}
          width="120"
          height="120"
          style={{
            objectFit: "cover",
            borderRadius: "12px",
          }}
        />
      </div>

      {/* NAME */}
      <h3 className="mb-2">
        {data?.name}
      </h3>

      {/* STATUS */}
      <div
        className={
          data?.status === "active"
            ? "view-status-badge active-badge"
            : "view-status-badge inactive-badge"
        }
      >
        {
          data?.status === "active"
            ? "Active"
            : "Inactive"
        }
      </div>

      {/* DETAILS */}
      <div className="view-details-grid mt-4">

        <div className="view-detail-card">
          <span>Name</span>

          <h5>
            {data?.name}
          </h5>
        </div>

        <div className="view-detail-card">
          <span>Description</span>

          <h5>
            {data?.description || "N/A"}
          </h5>
        </div>

      </div>

    </div>
  );
}

export default ViewAmenities;